<template>
  <div style="padding-right: 30px">
    <el-form ref="form" :model="form" label-width="80px" :disabled="true">
      <el-form-item label="实际承运人姓名">
        <el-input v-model="form.driverName"></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input v-model="form.vehicleLicense"></el-input>
      </el-form-item>
      <el-form-item label="现场照片">
        <el-row>
          <el-col
            :span="11"
            offset="1"
            v-for="(item, i) in form.sceneImgList"
            :key="i"
          >
            <el-image style="width: 100%" :src="item"></el-image>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input type="textarea" v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-input v-model="form.isRead"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getTransportAbnormalDetail } from "@/api/CustomerService";
export default {
  name: "TransportAbnormalDetail",
  data() {
    return {
      form: {}
    };
  },
  created() {},
  methods: {
    getInfo(row) {
      this.form = {};
      getTransportAbnormalDetail(row.code).then(response => {
        this.form = response.data;
        this.form.driverName = row.driverName;
        this.form.vehicleLicense = row.vehicleLicense;
        this.form.isRead = this.form.isRead === 0 ? "未读" : "已读";
      });
    }
  }
};
</script>
